import { render } from "./PlayerNameInput.vue?vue&type=template&id=eb565da8&scoped=true"
import script from "./PlayerNameInput.vue?vue&type=script&lang=js"
export * from "./PlayerNameInput.vue?vue&type=script&lang=js"

import "./PlayerNameInput.vue?vue&type=style&index=0&id=eb565da8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb565da8"]])

export default __exports__